var React = require('react');

var BulletD3 = require('./BulletD3');

var Bullet = React.createClass({
    propTypes: {
        ranges: React.PropTypes.array,
        measures: React.PropTypes.array,
        markers: React.PropTypes.array,

        width: React.PropTypes.number.isRequired,
        height: React.PropTypes.number
    },

    getDefaultProps: function() {
        return {
            measures: [],
            markers: [],
            ranges: []
        };
    },

    dispatcher: null,

    componentDidMount: function() {
        var el = this.getDOMNode();

        BulletD3.create(el, {width: this.props.width, height: this.props.height}, this.getChartState());
    },

    componentDidUpdate: function() {
        var el = this.getDOMNode();

        BulletD3.update(el, {width: this.props.width, height: this.props.height}, this.getChartState());
    },

    getChartState: function() {
        return {
            ranges: this.props.ranges,
            measures: this.props.measures,
            markers: this.props.markers
        };
    },

    render: function() {
        return <div className="bullet"></div>;
    }
});
module.exports = Bullet;



// WEBPACK FOOTER //
// ./app/components/Chart/Bullet.js